import { updateObject } from "utils/helpers/updateObject";
import { CommercialUser, initialState } from "./state";
import {
  actionTypes,
  CheckForExistingCommercialUserByEmailFailAction,
  CheckForExistingCommercialUserByEmailRequestAction,
  CheckForExistingCommercialUserByEmailSuccessAction,
  CheckForExistingCommercialUserByMobileFailAction,
  CheckForExistingCommercialUserByMobileRequestAction,
  CheckForExistingCommercialUserByMobileSuccessAction,
  CommercialUserActions,
  CreateCommercialUserFailAction,
  CreateCommercialUserRequestAction,
  CreateCommercialUserSuccessAction,
  FetchCommercialActiveUsersFailureAction,
  FetchCommercialActiveUsersRequestAction,
  FetchCommercialActiveUsersSuccessAction,
  FetchCommercialNewRegisterFailureAction,
  FetchCommercialNewRegisterRequestAction,
  FetchCommercialNewRegisterSuccessAction,
  FetchCommercialUserByIdFailureAction,
  FetchCommercialUserByIdRequestAction,
  FetchCommercialUserByIdSuccessAction,
  FetchCommercialUserProfileByUserIdFailureAction,
  FetchCommercialUserProfileByUserIdRequestAction,
  FetchCommercialUserProfileByUserIdSuccessAction,
  FetchCommercialUsersFailureAction,
  FetchCommercialUsersRequestAction,
  FetchCommercialUsersSuccessAction,
  FilterUserFailAction,
  FilterUserRequestAction,
  FilterUserSuccessAction,
  ResetCommercialDetails,
  ResetCommercialUserPasswordFailAction,
  ResetCommercialUserPasswordRequestAction,
  ResetCommercialUserPasswordSuccessAction,
  stateStatusType,
  UpdateCommercialUserFailAction,
  UpdateCommercialUserRequestAction,
  UpdateCommercialUserStatusFailAction,
  UpdateCommercialUserStatusRequestAction,
  UpdateCommercialUserStatusSuccessAction,
  UpdateCommercialUserSuccessAction,
} from "./actionType";

//FetchCommercailUser
const FetchCommercialUsersRequest = (
  state: CommercialUser,
  action: FetchCommercialUsersRequestAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const FetchCommercialUsersSuccess = (
  state: CommercialUser,
  action: FetchCommercialUsersSuccessAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      commercialUsers: action.payload,
    },
  });
};
const FetchCommercialUsersFail = (
  state: CommercialUser,
  action: FetchCommercialUsersFailureAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//FetchCommercialuser by id
const FetchCommercialUserByIdRequest = (
  state: CommercialUser,
  action: FetchCommercialUserByIdRequestAction
) => {
  return updateObject(state, {
    commercialUserByIdState: {
      ...state.commercialUserByIdState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const FetchCommercialUserByIdSuccess = (
  state: CommercialUser,
  action: FetchCommercialUserByIdSuccessAction
) => {
  return updateObject(state, {
    commercialUserByIdState: {
      ...state.commercialUserByIdState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      commercialUser: action.payload,
    },
  });
};
const FetchCommercialUserByIdFail = (
  state: CommercialUser,
  action: FetchCommercialUserByIdFailureAction
) => {
  return updateObject(state, {
    commercialUserByIdState: {
      ...state.commercialUserByIdState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//FetchCommercialuserProfile by id
const FetchCommercialProfileRequest = (
  state: CommercialUser,
  action: FetchCommercialUserProfileByUserIdRequestAction
) => {
  return updateObject(state, {
    commercialUserProfileState: {
      ...state.commercialUserProfileState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const FetchCommercialProfileSuccess = (
  state: CommercialUser,
  action: FetchCommercialUserProfileByUserIdSuccessAction
) => {
  return updateObject(state, {
    commercialUserProfileState: {
      ...state.commercialUserProfileState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      commercialUserProfile: action.payload,
    },
  });
};
const FetchCommercialProfileFail = (
  state: CommercialUser,
  action: FetchCommercialUserProfileByUserIdFailureAction
) => {
  return updateObject(state, {
    commercialUserProfileState: {
      ...state.commercialUserProfileState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//FetchCommercailACTIVEUser
const FetchCommercialUsersActiveRequest = (
  state: CommercialUser,
  action: FetchCommercialActiveUsersRequestAction
) => {
  return updateObject(state, {
    commercialActiveUserState: {
      ...state.commercialActiveUserState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const FetchCommercialUsersActiveSuccess = (
  state: CommercialUser,
  action: FetchCommercialActiveUsersSuccessAction
  
) => {
  return updateObject(state, {
    commercialActiveUserState: {
      ...state.commercialActiveUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      commercialActiveUsers: action.payload,
    },
  });
};
const FetchCommercialUsersActiveFail = (
  state: CommercialUser,
  action: FetchCommercialActiveUsersFailureAction
) => {
  return updateObject(state, {
    commercialActiveUserState: {
      ...state.commercialActiveUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//FetchCommercailneweRegister
const FetchCommercialNewRegisterRequest = (
  state: CommercialUser,
  action: FetchCommercialNewRegisterRequestAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const FetchCommercialNewRegisterSuccess = (
  state: CommercialUser,
  action: FetchCommercialNewRegisterSuccessAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      newRegisterUsers: action.payload,
    },
  });
};
const FetchCommercialNewRegisterFail = (
  state: CommercialUser,
  action: FetchCommercialNewRegisterFailureAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//createCommercialuser
const createCommercialUserRequest = (
  state: CommercialUser,
  action: CreateCommercialUserRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const createCommercialUserSuccess = (
  state: CommercialUser,
  action: CreateCommercialUserSuccessAction
) => {
  const existingUser = state.commercialUserState.commercialUsers ?? [];
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    commercialUserState: {
      ...state.commercialUserState,
      commercialUsers: [...existingUser, action.payload],
    },
  });
};

const createCommercialUserFail = (
  state: CommercialUser,
  action: CreateCommercialUserFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//updateCommercialUser
const updateCommercialUserRequest = (
  state: CommercialUser,
  action: UpdateCommercialUserRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const updateCommercialUserSuccess = (
  state: CommercialUser,
  action: UpdateCommercialUserSuccessAction
) => {
  const newUsers = state.commercialUserState.commercialUsers?.map((item) =>
    item.id === action.payload.id ? action.payload : item
  ) ?? [action.payload];
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    commercialUserState: {
      ...state.commercialUserState,
      commercialUsers: [...newUsers],
    },
  });
};

const updateCommercialUserFail = (
  state: CommercialUser,
  action: UpdateCommercialUserFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//CheckForExistingCommercialUserByMobile
const checkForExistingUserByMobileRequest = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByMobileRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByMobileSuccess = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByMobileSuccessAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByMobileFail = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByMobileFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      status: stateStatusType.FAILED,
      isLoading: false,
    },
    commercialUserState: {
      ...state.commercialUserState,
      error: action.payload,
    },
  });
};

//CheckForExistingCommercialUserByMobile
const checkForExistingUserByEmailRequest = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByEmailRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByEmailSuccess = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByEmailSuccessAction
) => {
  return updateObject(state, {
    commercialUserState: {
      ...state.commercialUserState,
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByEmailFail = (
  state: CommercialUser,
  action: CheckForExistingCommercialUserByEmailFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
    commercialUserState: {
      ...state.commercialUserState,
      error: action.payload,
    },
  });
};

//updateCommercialIUserStatus
const updateCommercialUserStatusRequest = (
  state: CommercialUser,
  action: UpdateCommercialUserStatusRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const updateCommercialUserStatusSuccess = (
  state: CommercialUser,
  action: UpdateCommercialUserStatusSuccessAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    commercialUserState: {
      ...state.commercialUserState,
      commercialUsers: { ...action.payload },
    },
  });
};

const updateCommercialUserStatusFail = (
  state: CommercialUser,
  action: UpdateCommercialUserStatusFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//resetPassword
const resetCommercialUserPasswordRequest = (
  state: CommercialUser,
  action: ResetCommercialUserPasswordRequestAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const resetCommercialUserPasswordSuccess = (
  state: CommercialUser,
  action: ResetCommercialUserPasswordSuccessAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    commercialUserState: {
      ...state.commercialUserState,
    },
  });
};

const resetCommercialUserPasswordFail = (
  state: CommercialUser,
  action: ResetCommercialUserPasswordFailAction
) => {
  return updateObject(state, {
    genericCommercialUserState: {
      ...state.genericCommercialUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};
const filterUserRequest = (
  state: CommercialUser,
  action: FilterUserRequestAction
) => {
  return updateObject(state, {
    filterUserState: {
      ...state.filterUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const filterUserSuccess = (
  state: CommercialUser,
  action: FilterUserSuccessAction
) => {
  return updateObject(state, {
    filterUserState: {
      ...state.filterUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
      filteredUser:action.payload
    },
  });
};

const filterUserFail = (
  state: CommercialUser,
  action: FilterUserFailAction
) => {
  return updateObject(state, {
    filterUserState: {
      ...state.filterUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};
const resetCommercialUserDetails = (
  state: CommercialUser,
  action: ResetCommercialDetails
) => ({
  ...state,
  commercialUserState: { ...initialState.commercialUserState },
  genericCommercialUserState: { ...initialState.genericCommercialUserState },
});

const CommercialUserReducer = (
  state = initialState,
  action: CommercialUserActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_COMMERCIAL_USERS_REQUEST:
      return FetchCommercialUsersRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_USERS_SUCCESS:
      return FetchCommercialUsersSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_USERS_FAIL:
      return FetchCommercialUsersFail(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_REQUEST:
      return FetchCommercialProfileRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_SUCCESS:
      return FetchCommercialProfileSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_FAIL:
      return FetchCommercialProfileFail(state, action);
    case actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_REQUEST:
      return FetchCommercialUsersActiveRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_SUCCESS:
      return FetchCommercialUsersActiveSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_FAIL:
      return FetchCommercialUsersActiveFail(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_BY_ID_REQUEST:
      return FetchCommercialUserByIdRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_BY_ID_SUCCESS:
      return FetchCommercialUserByIdSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_USER_BY_ID_FAIL:
      return FetchCommercialUserByIdFail(state, action);
    case actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_REQUEST:
      return FetchCommercialNewRegisterRequest(state, action);
    case actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_SUCCESS:
      return FetchCommercialNewRegisterSuccess(state, action);
    case actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_FAIL:
      return FetchCommercialNewRegisterFail(state, action);
    case actionTypes.CREATE_COMMERCIAL_USER_REQUEST:
      return createCommercialUserRequest(state, action);
    case actionTypes.CREATE_COMMERCIAL_USER_SUCCESS:
      return createCommercialUserSuccess(state, action);
    case actionTypes.CREATE_COMMERCIAL_USER_FAIL:
      return createCommercialUserFail(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_REQUEST:
      return updateCommercialUserRequest(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_SUCCESS:
      return updateCommercialUserSuccess(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_FAIL:
      return updateCommercialUserFail(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_STATUS_REQUEST:
      return updateCommercialUserStatusRequest(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_STATUS_SUCCESS:
      return updateCommercialUserStatusSuccess(state, action);
    case actionTypes.UPDATE_COMMERCIAL_USER_STATUS_FAIL:
      return updateCommercialUserStatusFail(state, action);
    case actionTypes.RESET_COMMERCIAL_USER_PASSWORD_REQUEST:
      return resetCommercialUserPasswordRequest(state, action);
    case actionTypes.RESET_COMMERCIAL_USER_PASSWORD_SUCCESS:
      return resetCommercialUserPasswordSuccess(state, action);
    case actionTypes.RESET_COMMERCIAL_USER_PASSWORD_FAIL:
      return resetCommercialUserPasswordFail(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_REQUEST:
      return checkForExistingUserByEmailRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_SUCCESS:
      return checkForExistingUserByEmailSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_FAIL:
      return checkForExistingUserByEmailFail(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_REQUEST:
      return checkForExistingUserByMobileRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_SUCCESS:
      return checkForExistingUserByMobileSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_FAIL:
      return checkForExistingUserByMobileFail(state, action);
    case actionTypes.FILTER_USER_REQUEST:
      return filterUserRequest(state, action);
    case actionTypes.FILTER_USER_SUCCESS:
      return filterUserSuccess(state, action);
    case actionTypes.FILTER_USER_FAIL:
      return filterUserFail(state, action);
    case actionTypes.RESET_COMMERCIAL_DETAILS:
      return resetCommercialUserDetails(state, action);
    default:
      return state;
  }
};

export default CommercialUserReducer;
